//请自行添加语言资源
const income = {
  checkoutStatus: '结算状态',
  checkoutMethod: '结算方式',
  shipperCode: '货主编码',
  shipperName: '货主',
  projectName: '项目',
  customerOrderNo: '客户订单号',
  soOrSto: '客户相关单号',
  truckNo: '车牌号',
  orderDate: '订单日期',
  carrierName: '承运商名称',
  originNo: '发货仓编号',
  originName: '发货仓名称',
  destNo: '收货方编号',
  destName: '收货方名称',
  destProvince: '收货省',
  destCity: '收货市',
  destDistrict: '收货区县',
  destAddress: '收货地址',
  deliverGoodsTime: '发货时间',
  route: '线路',
  realityReachTime: '实际到达时间',
  totalQty: '总数量',
  totalGrossWeight: '总毛重',
  totalVolume: '总体积',
  freight: '运费',
  upstairsFee: '上楼费',
  terminalCharges: '装卸费',
  valueAddedIncome: '增值收入',
  elseIncome: '其他收入',
  totalExpense: '总费用',
  remark: '备注',
  costMismatchFlag:'成本订单信息是否一致',
};
export default income




// WEBPACK FOOTER //
// ./src/page/settlementFee/income/lang/income.zh.js